import axios from "./index.service";

export default class AuthService {
  static login(payload) {
    return axios({
      method: "POST",
      url: "/api/services/v1/auth/login",
      data: payload,
    });
  }

  static createPassword(password, otp) {
    return axios({
      method: "PUT",
      url: "/api/services/v1/auth/create-password",
      params: {
        password: password,
        otp: otp,
      },
    });
  }

  static forgetPassword(email) {
    return axios({
      method: "GET",
      url: "/api/services/v1/auth/forget-password",
      params: {
        email: email,
      },
    });
  }

  static resetPassword(otp, newPassword) {
    return axios({
      method: "PUT",
      url: "/api/services/v1/auth/reset-password-with-otp",
      params: {
        otp: otp,
        newPassword: newPassword,
      },
    });
  }
}
